import React, { useState, useEffect, useRef, useMemo } from 'react';
import i18n from '@i18n';
import { Autocomplete, store as zerocodeStore } from 'zerocode';
import { connect } from 'react-redux';
import { renderExecutionFlowMenuItem, renderTaskMenuItem, sortByUrgency } from '@custom/common';
import '@assets/sass/dashboard.scss';
import Chart from 'react-apexcharts';
import Icon from '@custom/Icon';
import WorkflowActionCard, { workflowCollection, checkLicenses } from '../@custom/WorkflowActionCard';
import { Button } from '@material-ui/core';
// import { FixedSizeList as List } from 'react-window';

const Dashboard = ({ auth, executionFlowStore, executionFlowStoreMine, taskStore, companyAreaStore, recurrenceStore }) => {
	const [workflows, setWorkflows] = useState([]);
	const [donutA, setDonutA] = useState({ options: { labels: [] }, series: [] });
	const [hasLicensesMappings, setHasLicensesMappings] = useState(false);
	const [maxMappingsLicensesAvailable, setMaxMappingsLicensesAvailable] = useState(false);

	const debounceDonutRef = useRef();
	const debounceAuthRef = useRef();
	const appcenterStore = zerocodeStore.getState().appcenter;

	// useEffect(() => {
	// 	console.log('executionFlowStoreeeeeeeeee', executionFlowStore);
	// 	console.log('executionFlowStoreMine', executionFlowStoreMine);
	// }, [executionFlowStore, executionFlowStoreMine]);

	useEffect(() => {
		checkLicenses((result) => {
			setHasLicensesMappings(result.hasEnoughMappingsLicense);
			setMaxMappingsLicensesAvailable(result.mappingsLicensesAvailable);
		});
	}, [appcenterStore.licenses]);

	useEffect(() => {
		clearTimeout(debounceAuthRef.current);
		debounceAuthRef.current = setTimeout(() => {
			workflowCollection
				.where('company', '==', auth.company.uid)
				.where('deleted', '==', false)
				.get()
				.then((snapshot) => {
					const filtered = snapshot.docs
						.map((d) => d.data())
						.filter((o) => {
							if (!o.division) return false;
							if (auth.user.companyadmin) return true;

							const ca = companyAreaStore.list.find((c) => c.uid === o.division);
							if (!ca || !ca.groups?.length) return false;

							return ca.groups.some((group) => auth.user.groups.some((uGroup) => uGroup.uid === group.uid));
						})
						.sortBy(['divisionObject.name', 'document.title']);

					setWorkflows(filtered);
				});
		}, 400);
	}, [auth.isAuthenticated]);

	const donutData = useMemo(() => {
		const wfMap = {};
		taskStore.list.forEach((task) => {
			const wf = wfMap[task.workflow] || {
				count: 0,
				label: task.workflowObject.document.title,
			};
			wf.count++;
			wfMap[task.workflow] = wf;
		});

		return {
			labels: Object.values(wfMap).map((o) => o.label),
			series: Object.values(wfMap).map((o) => o.count),
		};
	}, [taskStore.list]);

	useEffect(() => {
		clearTimeout(debounceDonutRef.current);
		debounceDonutRef.current = setTimeout(() => {
			setDonutA({
				options: { labels: donutData.labels },
				series: donutData.series,
			});
		}, 500);
	}, [donutData]);

	const sortedTasks = useMemo(() => {
		return [...taskStore.list].sort(sortByUrgency);
	}, [taskStore.list]);

	const sortedMineFlows = useMemo(() => {
		return [...executionFlowStoreMine.list].sort(sortByUrgency);
	}, [executionFlowStoreMine.list]);

	const sortedResponsibleFlows = useMemo(() => {
		return [...executionFlowStore.list].sort(sortByUrgency);
	}, [executionFlowStore]);

	const [mineVisibleCount, setMineVisibleCount] = useState(5);
	const [responsibleVisibleCount, setResponsibleVisibleCount] = useState(5);

	const [myActivities, setMyActivities] = useState(5);

	const FlowItem = React.memo(({ data, index, style }) => <div style={style}>{renderExecutionFlowMenuItem(data[index])}</div>);

	return (
		<content>
			<div className="workflow-search-container">
				<Autocomplete
					preventCloseOnBlur
					className="workflow-search"
					items={workflows}
					label={i18n('workflow.dashboard.labelSearchProcess')}
					leftIcon="faSearch"
					getComparisonText={(option) =>
						`${option.document.title} ${option.divisionObject.name} ${option.document.description || ''}`
					}
					renderItem={(workflow) => [
						<WorkflowActionCard
							key={workflow.uid}
							displayDivision
							auth={auth}
							workflow={workflow}
							companyAreaStore={companyAreaStore}
							recurrenceStore={recurrenceStore}
							hasLicensesMappings={hasLicensesMappings}
							maxMappingsLicensesAvailable={maxMappingsLicensesAvailable}
						/>,
					]}
				/>
			</div>

			<header>
				<h3>
					<Icon icon="faChartPie" />
					Dashboard
				</h3>
			</header>

			<div className="columns graphic-line">
				<div className="column tasks">
					<h3>
						<Icon icon="faTasks" />
						{i18n('workflow.dashboard.titleMyActivities')}
					</h3>
					<div className="items">{sortedTasks.slice(0, myActivities).map(renderTaskMenuItem)}</div>
					<div className="load-more-container">
						{myActivities < sortedTasks.length && (
							<Button
								size="small"
								variant="contained"
								color="primary"
								onClick={() => setMyActivities(myActivities + 10)}
							>
								Carregar mais
							</Button>
						)}
					</div>
				</div>
				<div className="column">
					{!!donutA.options.labels.length && (
						<Chart
							style={{ height: 300, width: 300 }}
							options={donutA.options}
							series={donutA.series}
							type="donut"
							width="400px"
							height="500px"
						/>
					)}
				</div>
			</div>

			<div className="dashboard-grid">
				<div className="box">
					<h3>
						<Icon icon="faSitemap" />
						{i18n('appcommon.menutop.executionFlowsICreated')} ({sortedMineFlows.length})
					</h3>
					<div className="items">
						{sortedMineFlows.slice(0, mineVisibleCount).map(renderExecutionFlowMenuItem)}
						{mineVisibleCount < sortedMineFlows.length && (
							<Button
								size="small"
								variant="contained"
								color="primary"
								onClick={() => setMineVisibleCount(mineVisibleCount + 10)}
							>
								Carregar mais
							</Button>
						)}
					</div>
				</div>

				<div className="box">
					<h3>
						<Icon icon="faSitemap" />
						{i18n('appcommon.menutop.executionFlowsImResponsible')} ({sortedResponsibleFlows.length})
					</h3>
					<div className="items">
						{sortedResponsibleFlows.slice(0, responsibleVisibleCount).map(renderExecutionFlowMenuItem)}
					</div>
					{responsibleVisibleCount < sortedResponsibleFlows.length && (
						<Button
							size="small"
							variant="contained"
							color="primary"
							onClick={() => setResponsibleVisibleCount(responsibleVisibleCount + 10)}
						>
							Carregar mais
						</Button>
					)}
				</div>
			</div>
		</content>
	);
};

export default connect(({ auth, executionFlow, myExecutionFlowStore, task, companyAreaStore, recurrenceStore }) => ({
	auth,
	executionFlowStore: executionFlow,
	executionFlowStoreMine: myExecutionFlowStore,
	taskStore: task,
	companyAreaStore,
	recurrenceStore,
}))(Dashboard);
